import { useEffect, useRef } from "react";
import SignatureCanvas from "react-signature-canvas";
import { useLang } from "../i18n/LanguageContext";

export default function SignaturePad({ onChange, errored }) {
  const ref = useRef(null);
  const { t } = useLang();

  const handleEnd = () => {
    if (ref.current && !ref.current.isEmpty()) {
      const dataUrl = ref.current.toDataURL("image/png");
      onChange(dataUrl);
    } else {
      onChange("");
    }
  };

  const clear = () => {
    ref.current?.clear();
    onChange("");
  };

  useEffect(() => {
    // Resize canvas to container width
    const resize = () => {
      if (!ref.current) return;
      const canvas = ref.current.getCanvas();
      const ratio = Math.max(window.devicePixelRatio || 1, 1);
      const parent = canvas.parentElement;
      if (parent) {
        canvas.width = parent.offsetWidth * ratio;
        canvas.height = 192 * ratio;
        canvas.style.width = `${parent.offsetWidth}px`;
        canvas.style.height = `192px`;
        canvas.getContext("2d").scale(ratio, ratio);
      }
    };
    resize();
    window.addEventListener("resize", resize);
    return () => window.removeEventListener("resize", resize);
  }, []);

  return (
    <div className="space-y-2">
      <div
        className={`relative rounded-xl bg-[#080808] border ${
          errored ? "border-[#e05555]" : "border-[#252525]"
        } overflow-hidden transition-colors`}
        data-testid="signature-wrapper"
      >
        <SignatureCanvas
          ref={ref}
          penColor="#e8559a"
          onEnd={handleEnd}
          canvasProps={{
            className: "block w-full touch-none cursor-crosshair",
            "data-testid": "signature-canvas",
          }}
        />
        <div className="absolute bottom-2 right-3 text-[10px] uppercase tracking-widest text-neutral-600 pointer-events-none">
          {t("tagline")}
        </div>
      </div>
      <div className="flex items-center justify-between text-xs">
        <span className="text-neutral-500">{t("signature_help")}</span>
        <button
          type="button"
          onClick={clear}
          data-testid="clear-signature-btn"
          className="text-[#e8559a] hover:text-[#c9407f] font-medium transition-colors"
        >
          {t("clear_signature")}
        </button>
      </div>
    </div>
  );
}
